import React from 'react'
import PropTypes from 'prop-types'
import { StyledInput } from '../style'

const Text = ({ isValid, ...props }) => (
  <>
    <StyledInput type="text" isValid={isValid} {...props} />
  </>
)

Text.propTypes = {
  isValid: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  dataCy: PropTypes.string,
}

export default Text
